<template>
  <v-container class="fill-height" fluid>
    <v-app-bar app color="primary" dark class="bg_toolbar" height="70px">
      <v-card
        v-if="!mobile"
        class="bg_appbar_logo"
        flat
        color="white"
        style=" border-radius: 0px 50px 50px 0px;"
      >
        <v-row justify="center" align="center">
          <v-col align="center" cols="12" class="pb-0 pt-2 pl-1">
            <v-img :src="require('../assets/royin-logo2.png')" max-width="40"></v-img>
          </v-col>
        </v-row>
      </v-card>
      <div v-if="mobile" class="ml-2">
        <v-img :src="require('@/assets/royin-logo2.png')" max-width="30"></v-img>
      </div>
      <v-toolbar-title v-if="!mobile" style="margin-left:120px">
        <h2>ระบบฐานข้อมูลคำทับศัพท์ของสำนักงานราชบัณฑิตยสภา</h2>
      </v-toolbar-title>
      <v-toolbar-title v-if="mobile" style="margin-left:15px">
        <span style="font-size:18px">ระบบฐานข้อมูลคำทับศัพท์ของสำนักงานราชบัณฑิตยสภา</span>
      </v-toolbar-title>
      <!-- <v-toolbar-title style="margin-left:120px" v-if="!mobile">
        <h2>ระบบฐานข้อมูลคำทับศัพท์ของสำนักงานราชบัณฑิตยสภา</h2>
      </v-toolbar-title>-->
    </v-app-bar>
    <!-- {{ tablet }}
    {{ desktop }}-->
    <v-row align="center" justify="center">
      <v-col cols="12" class="card_login">
        <v-card class="mx-auto" max-width="1000px">
          <v-row>
            <v-col cols="12" sm="6" md="6" class="py-0 d-none d-sm-flex">
              <v-img
                style="background-position:center;"
                :src="
                  tablet
                    ? require('../assets/BG1-small.jpg')
                    : require('../assets/BG1.jpg')
                "
              ></v-img>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="pa-0">
              <v-container class="px-5 py-10">
                <v-card-title class="justify-center mb-10">
                  <h2>เข้าสู่ระบบ</h2>
                </v-card-title>

                <v-form ref="login_form" @submit.prevent="login()">
                  <v-card-text class="text--primary">
                    <span class="text_body_4 mb-1">ชื่อผู้ใช้</span>
                    <v-text-field
                      v-model="username"
                      outlined
                      dense
                      :rules="rule_is_empty"
                      placeholder="กรอกชื่อผู้ใช้ของคุณ เช่น natcha.00"
                    ></v-text-field>
                    <span class="text_body_4 mb-1">รหัสผ่าน</span>
                    <v-text-field
                      v-model="password"
                      outlined
                      dense
                      :rules="rule_is_empty"
                      placeholder="กรอกรหัสผ่านของคุณ"
                      type="password"
                    ></v-text-field>
                    <v-row>
                      <v-col cols="6" style="margin-top:-45px;">
                        <v-checkbox class="rememberme" v-model="remember_me" label="จดจำฉันในระบบ"></v-checkbox>
                      </v-col>
                      <v-col cols="6" style="margin-top:-25px" class="text-right">
                        <a style="color:#6aa7e0;">
                          <span class="text_body_6" @click="goPage('/forget_password')">ลืมรหัสผ่าน?</span>
                        </a>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-col class="py-0">
                    <v-card-actions>
                      <v-btn class="bg_btn_gradient" block dark type="submit">
                        <h4>ลงชื่อเข้าใช้</h4>
                      </v-btn>
                    </v-card-actions>
                  </v-col>
                </v-form>
                <!-- <v-col cols="12" class="text-center">
                  <span class="7">คุณยังไม่มีบัญชี ใช่หรือไม่ ?</span>
                  <a href="" class="ml-2" style="color:#6aa7e0"
                    ><span class="7">ลงทะเบียน</span>
                  </a>
                </v-col>-->
              </v-container>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { isEmptyTextField } from "@/assets/javascript/rules.js";
export default {
  data() {
    return {
      header_token: {
        headers: {
          token: "token_inet_dev",
        },
      },
      username: "",
      password: "",
      remember_me: false,
      // rules
      rule_is_empty: isEmptyTextField,
    };
  },

  computed: {
    size() {
      return this.$vuetify.breakpoint.width;
    },
    mobile() {
      if (
        this.$vuetify.breakpoint.width >= 320 &&
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 768 &&
        this.$vuetify.breakpoint.width < 1440
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (this.$vuetify.breakpoint.width >= 1440) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.$session.clear();
  },
  methods: {
    login() {
      if (this.$refs.login_form.validate()) {
        let data = {
          username: this.username,
          password: this.password,
        };
        this.axios
          .post(
            process.env.VUE_APP_API + "api/v1/login",
            data,
            this.header_token
          )
          .then((response) => {
            // console.log(response.data);
            if (response.data.message == "success") {
              // insert userid && token && rememberme Fn into session
              this.$session.set(
                "user_id_roy",
                response.data.information.userId
              );
              this.$session.set("token_roy", response.data.token);
              this.$session.set("remember_me", this.remember_me);
              this.$session.set("sessionTime", new Date());
              // insert information into session
              this.$session.set(
                "fullname",
                response.data.information.firstName +
                  " " +
                  response.data.information.lastName
              );
              this.$session.set("email", response.data.information.email);
              // insert permission into session
              // SET PERMISSION !!!!
              this.$session.set(
                "permission_permissionName",
                response.data.permission[0].permissionName
              );
              this.$session.set(
                "permission_backOffice",
                response.data.permission[0].backOffice
              );
              this.$session.set(
                "permission_setting",
                response.data.permission[0].setting
              );
              this.$swal.fire({
                icon: "success",
                title: "เข้าสู่ระบบสำเร็จ",
                showConfirmButton: false,
                timer: 1000,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                stopKeydownPropagation: false,
              });
              this.$router.push(process.env.VUE_APP_HOME);
            } else {
              this.$swal.fire({
                icon: "warning",
                title: "ชื่อผู้ใช้ หรือ รหัสผ่าน ไม่ถูกต้อง",
                text: "โปรดทำการเข้าสู่ระบบใหม่อีกครั้ง",
                timerProgressBar: true,
                showConfirmButton: false,
                timer: 2500,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                stopKeydownPropagation: false,
              });
            }
            this.username = "";
            this.password = "";
          })
          .catch((err) => {
            // console.log("api login err");
          });
      } else {
        this.$swal.fire(
          "ข้อมูลไม่สมบูรณ์!",
          "กรุณากรอกข้อมูลใหม่อีกครั้ง",
          "warning"
        );
      }
    },
    goPage(path) {
      this.$router.push(path);
    },
  },
};
</script>
